// extracted by mini-css-extract-plugin
export default {"blog-wrapper":"Blog_blog-wrapper__s87CY","addButton":"Blog_addButton__e0nYJ"};